<template>
    <b-card class="mb-1" no-body header-class="pt-0 px-0">
        <template #header>
            <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                    <feather-icon icon="ImageIcon" size="18" class="mr-50" />
                    <h5 class="mb-0">Medya Dosyaları</h5>
                </div>
                <b-badge variant="light-primary" class="ml-50" pill>{{ localMediaFiles.length }} Dosya</b-badge>
            </div>
        </template>

        <div class="mb-2">
            <b-button variant="primary" size="sm" @click="$emit('open-gallery')">
                <feather-icon icon="FolderIcon" size="14" class="mr-25" />
                Dosya Seç
            </b-button>
        </div>

        <div v-if="localMediaFiles.length > 0">
            <draggable v-model="localMediaFiles" handle=".drag-handle" @end="updateSortOrder">
                <transition-group name="flip-list" tag="div" class="media-list">
                    <div v-for="(media, index) in localMediaFiles" :key="media.SortOrder + '-' + index" class="media-item-card mb-1">
                        <div class="media-item-left">
                            <feather-icon icon="MenuIcon" size="18" class="drag-handle mr-1" />

                            <div
                                class="media-preview rounded mr-1 bg-light d-flex align-items-center justify-content-center border"
                                style="width: 48px; height: 48px; overflow: hidden; flex-shrink: 0"
                            >
                                <img v-if="media.MediaType === 'image' && media.FilePath" :src="getFileUrl(media.FilePath)" class="img-fluid" style="width: 100%; height: 100%; object-fit: cover" />
                                <feather-icon v-else icon="FileIcon" size="20" class="text-muted" />
                            </div>

                            <div class="d-flex flex-column" style="min-width: 0">
                                <span class="font-weight-bold text-truncate text-dark" style="font-size: 0.9rem" :title="media.Title">
                                    {{ media.Title || "Başlıksız" }}
                                </span>
                                <div class="d-flex align-items-center mt-25">
                                    <b-badge variant="light-info" style="font-size: 0.7rem" class="mr-50">{{ media.MediaType }}</b-badge>
                                    <small class="text-muted">Sıra: {{ index }}</small>
                                </div>
                            </div>
                        </div>

                        <div class="media-item-right">
                            <b-form-input v-model="media.Alt" size="sm" placeholder="Alt Text" class="mr-1 d-none d-md-block" style="width: 150px" />

                            <b-button variant="flat-danger" size="sm" class="btn-icon" @click="removeMedia(index)">
                                <feather-icon icon="TrashIcon" size="16" />
                            </b-button>
                        </div>
                    </div>
                </transition-group>
            </draggable>
        </div>

        <div v-else class="border rounded p-4 text-center theme-item">
            <feather-icon icon="ImageIcon" size="32" class="text-muted mb-1" />
            <p class="text-muted mb-0">Henüz medya dosyası eklenmedi.</p>
        </div>
    </b-card>
</template>

<script>
import { BCard, BButton, BBadge, BFormInput } from "bootstrap-vue";
import draggable from "vuedraggable";
import Utilities from "@/utilities/system/index";

export default {
    name: "ContentMediaManager",
    components: {
        BCard,
        BButton,
        BBadge,
        BFormInput,
        draggable,
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        localMediaFiles: {
            get() {
                return this.value || [];
            },
            set(val) {
                this.$emit("input", val);
            },
        },
    },
    methods: {
        getFileUrl(path) {
            if (!path) return "";
            if (path.startsWith("http")) return path;

            let baseUrl = Utilities.BaseURL.URL;
            if (!baseUrl || baseUrl === "undefined" || baseUrl === "") {
                baseUrl = "https://localhost:7287";
            }
            return `${baseUrl.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
        },
        removeMedia(index) {
            const newList = [...this.localMediaFiles];
            newList.splice(index, 1);
            this.updateSortOrder(newList);
        },
        updateSortOrder() {
            const updatedList = this.localMediaFiles.map((item, index) => ({
                ...item,
                SortOrder: index,
            }));
            this.$emit("input", updatedList);
        },
    },
};
</script>

<style scoped>
.media-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.media-item-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    transition: all 0.2s ease;
}

.media-item-card:hover {
    border-color: #d1d5db;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.media-item-left {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
}

.media-item-right {
    display: flex;
    align-items: center;
}

.drag-handle {
    color: #9ca3af;
    cursor: grab;
    flex-shrink: 0;
}

.drag-handle:active {
    cursor: grabbing;
}

.drag-handle:hover {
    color: #6b7280;
}

.flip-list-move {
    transition: transform 0.3s;
}

.border-dashed {
    border-style: dashed !important;
}

::v-deep .btn-icon {
    width: 32px;
    height: 32px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
